module.exports = __webpack_public_path__ + "img/PetraLogoFavicon.64abb250.png";